module.exports = __webpack_public_path__ + "static/img/doge-avatar.ff7f061c.jpg";